/*
 * @Description: 部门模块
 * @Author: 杨志航
 * @Date: 2026-09-06 14:49:32
 */
import update from 'immutability-helper'
import React, { useCallback, useState, useEffect, useImperativeHandle, forwardRef } from 'react'
import api from 'api'
import {
  Alert,
  message,
  Drawer,
} from 'antd'
import EditDepart from './EditDepart'
import DraggableTable from '@/components/DraggableTable'

const DepartSection = (props, ref) => {
  const { dataSource, getList } = props
  const [list, setList] = useState([])
  const [count, setCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const [editVisible, setEditVisible] = useState(false)
  const [editData, setEditData] = useState({})

  useImperativeHandle(ref, () => ({
    setLoadingState: (value = false) => {
      setLoading(value)
    },
  }))

  useEffect(() => {
    setList(dataSource)
    setCount(dataSource.length)
  }, [dataSource])

  const moveRow = useCallback((dragIndex, hoverIndex) => {
    const dragRow = list[dragIndex]
    const newData = update(list, {
      $splice: [
        [dragIndex, 1],
        [hoverIndex, 0, dragRow],
      ],
    })
    setList(newData)
  }, [list])

  const handleSort = () => {
    const names = list.map(item => item.groupName)
    const { groupId, departmentType } = list[0] || {}
    setLoading(true)
    api.updateProfitReportDepartSort({ 
      groupId,
      departmentType,
      groupName: names,
    }).then(() => {
      message.success('排序成功')
      getList()
    }).catch(() => getList())
  }

  const onEdit = record => {
    setEditData(record)
    setEditVisible(true)
  }

  const columns = [
    {
      title: '排序',
      dataIndex: 'sort',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'OA部门名称',
      dataIndex: 'groupName',
    },
    {
      title: '小程序部门名称',
      dataIndex: 'name',
    },
    {
      title: 'OA部门最高职级人',
      dataIndex: 'groupLeaderName',
    },
    {
      title: '小程序部门负责人',
      dataIndex: 'leaderName',
    },
    {
      title: '在职主账号人数',
      dataIndex: 'personNum',
    },
    {
      title: '操作',
      key: 'set',
      fixed: 'right',
      align: 'center',
      width: 80,
      render: (text, record) => <a onClick={() => onEdit(record)}>部门设置</a>,
    },
  ]

  return (
    <>
      <Alert className="corp-count" message={
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span>总共{count}条数据</span>
          <span style={{ marginLeft: 20, color: '#168FFF', cursor: 'pointer' }} onClick={handleSort}>保存排序</span>
        </div>
      } type="info" showIcon />
      <DraggableTable
        rowKey={(_, index) => index}
        size="small"
        dataSource={list}
        columns={columns}
        pagination={false}
        loading={loading}
        moveRow={moveRow}
      />
      <Drawer
        title="部门设置"
        width={600}
        onClose={() => setEditVisible(false)}
        visible={editVisible}
        destroyOnClose={true}
      >
        <EditDepart editData={editData} setVisible={setEditVisible} getList={getList} />
      </Drawer>
    </>
  )
}
export default forwardRef(DepartSection)